module.exports = __webpack_public_path__ + "img/whatsApp-white.e399f492.svg";